const dataContact = {
    section_title: "Contact.section_title",
    paragraph: "Contact.p",
    btn_email: "Contact.email",
    mailto: "mailto:ristespasov@hotmail.com"
}

export default dataContact